/* TAPE! Release Calendar filters (Phase 4F). Month/format/label/category on the full rendered set. */
(function () {
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var FORMAT_NAMES = { '4k': '4K UHD', bluray: 'Blu-ray', vinyl: 'Vinyl', cd: 'CD', book: 'Book' };
  var CATEGORY_NAMES = { film: 'Film', music: 'Music', books: 'Books' };

  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }

  function initCalendar(root) {
    var sections = $$('.tape-cal-month', root);
    if (!sections.length) return;
    var months = sections.map(function (s) { return s.dataset.month; });
    var monthNames = {};
    sections.forEach(function (s) {
      var t = $('.tape-cal-month__title', s);
      monthNames[s.dataset.month] = t ? t.textContent.trim() : s.dataset.month;
    });
    var labelSelect = $('[data-label-filter]', root);
    var labelValues = labelSelect ? $$('option', labelSelect).map(function (o) { return o.value; }) : ['all'];
    var params = new URLSearchParams(location.search);
    var state = {
      month: months.indexOf(params.get('month')) >= 0 ? params.get('month') : root.dataset.defaultMonth,
      format: Object.prototype.hasOwnProperty.call(FORMAT_NAMES, params.get('format')) ? params.get('format') : 'all',
      category: Object.prototype.hasOwnProperty.call(CATEGORY_NAMES, params.get('category')) ? params.get('category') : 'all',
      label: labelValues.indexOf(params.get('label')) >= 0 ? params.get('label') : 'all'
    };
    var counts = {};
    var hashMatch = /^#d-(\d{4}-\d{2})-\d{2}$/.exec(location.hash);
    if (hashMatch && months.indexOf(hashMatch[1]) >= 0) state.month = hashMatch[1];

    function matches(row) {
      var fmt = (row.dataset.format || '').split(/\s+/).filter(Boolean);
      var fmtOk = state.format === 'all' || fmt.indexOf(state.format) >= 0;
      var labelOk = state.label === 'all' || row.dataset.label === state.label;
      var catOk = state.category === 'all' || row.dataset.category === state.category;
      return fmtOk && labelOk && catOk;
    }

    function url(month) {
      var p = new URLSearchParams();
      p.set('month', month || state.month);
      if (state.format !== 'all') p.set('format', state.format);
      if (state.category !== 'all') p.set('category', state.category);
      if (state.label !== 'all') p.set('label', state.label);
      return '?' + p.toString();
    }

    function nearestWithMatches() {
      var i = months.indexOf(state.month);
      for (var step = 1; step < months.length; step++) {
        var later = months[i + step];
        var earlier = months[i - step];
        if (later && counts[later] > 0) return later;
        if (earlier && counts[earlier] > 0) return earlier;
      }
      return null;
    }

    function apply() {
      sections.forEach(function (sec) {
        var total = 0;
        $$('.tape-cal-day', sec).forEach(function (day) {
          var n = 0;
          $$('.tape-cal-rel', day).forEach(function (row) {
            var ok = matches(row);
            row.hidden = !ok;
            if (ok) n++;
          });
          day.hidden = n === 0;
          var countEl = $('[data-day-count]', day);
          if (countEl) countEl.textContent = plural(n, 'release');
          total += n;
        });
        counts[sec.dataset.month] = total;
        sec.hidden = sec.dataset.month !== state.month;
      });

      $$('[data-month-link]', root).forEach(function (a) {
        var m = a.dataset.monthLink;
        if (m === state.month) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
        var c = $('[data-month-count]', a);
        if (c) c.textContent = String(counts[m] || 0);
        a.classList.toggle('is-empty', !(counts[m] > 0));
        a.href = url(m);
      });

      var idx = months.indexOf(state.month);
      $$('[data-month-step]', root).forEach(function (b) {
        var to = months[idx + Number(b.dataset.monthStep)];
        b.disabled = !to;
      });

      $$('[data-format]', root).forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.format === state.format ? 'true' : 'false');
      });
      $$('[data-category]', root).forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.category === state.category ? 'true' : 'false');
      });
      if (labelSelect) labelSelect.value = state.label;

      var filtered = state.format !== 'all' || state.label !== 'all' || state.category !== 'all';
      $$('[data-clear-filters]', root).forEach(function (b) { b.hidden = !filtered; });

      var n = counts[state.month] || 0;
      var bits = [];
      if (CATEGORY_NAMES[state.category]) bits.push(CATEGORY_NAMES[state.category]);
      if (FORMAT_NAMES[state.format]) bits.push(FORMAT_NAMES[state.format]);
      var what = (bits.length ? bits.join(' ') + ' ' : '') + 'release' + (n === 1 ? '' : 's');
      var from = state.label !== 'all' ? ' from ' + state.label : '';
      var summary = $('[data-cal-summary]', root);
      if (summary) summary.textContent = n + ' ' + what + from + ' in ' + (monthNames[state.month] || state.month) + '.';

      var empty = $('[data-cal-empty]', root);
      if (empty) {
        empty.hidden = n > 0;
        if (n === 0) {
          var emptyText = $('[data-cal-empty-text]', root);
          if (emptyText) {
            emptyText.textContent = 'No matching releases in ' + (monthNames[state.month] || state.month) +
              '. Try another filter, or jump to a month with matches.';
          }
          var jump = $('[data-jump-match]', root);
          var target = nearestWithMatches();
          if (jump) {
            jump.hidden = !target;
            if (target) {
              jump.dataset.target = target;
              jump.textContent = 'Show ' + monthNames[target] + ' (' + counts[target] + ')';
            }
          }
        }
      }
      if (history.replaceState) history.replaceState(null, '', url() + (location.hash || ''));
    }

    function go(month) {
      state.month = month;
      apply();
      var controls = $('.tape-cal-controls', root);
      if (controls && controls.getBoundingClientRect().top < 0) controls.scrollIntoView({ block: 'start' });
    }

    $$('[data-month-link]', root).forEach(function (a) {
      a.addEventListener('click', function (ev) { ev.preventDefault(); go(a.dataset.monthLink); });
    });
    $$('[data-month-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = months.indexOf(state.month) + Number(b.dataset.monthStep);
        if (i < 0 || i >= months.length) return;
        go(months[i]);
      });
    });
    $$('[data-format]', root).forEach(function (b) {
      b.addEventListener('click', function () { state.format = b.dataset.format; apply(); });
    });
    $$('[data-category]', root).forEach(function (b) {
      b.addEventListener('click', function () { state.category = b.dataset.category; apply(); });
    });
    if (labelSelect) {
      labelSelect.addEventListener('change', function () { state.label = labelSelect.value; apply(); });
    }
    $$('[data-clear-filters]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        state.format = 'all';
        state.label = 'all';
        state.category = 'all';
        apply();
      });
    });
    var jumpBtn = $('[data-jump-match]', root);
    if (jumpBtn) {
      jumpBtn.addEventListener('click', function (ev) { go(ev.currentTarget.dataset.target); });
    }

    apply();
    if (location.hash) {
      var el = document.getElementById(location.hash.slice(1));
      if (el && !el.closest('[hidden]')) {
        requestAnimationFrame(function () {
          var controls = $('.tape-cal-controls', root);
          var offset = controls && getComputedStyle(controls).position === 'sticky' ? controls.offsetHeight : 0;
          var top = el.getBoundingClientRect().top + window.pageYOffset - offset - 12;
          window.scrollTo(0, Math.max(0, top));
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cal = $('[data-tape-calendar]');
    if (cal) initCalendar(cal);
  });
})();
